export default "__VITE_ASSET__CyrW3sxr__"